   import {Injectable} from 'ng-metadata/core';

    @Injectable()
    export class MobileMenu {
        private isMobileMenu = false;
        private isLinksMenuVisible = false;
        private isDepositDisplay = false;
        constructor() {

        }

        public getMobileMenu() {
            return this.isMobileMenu;
        }

		public setMobileMenu(val) {
            this.isMobileMenu = val;
        }

		public getLinksMenuVisible() {
            return this.isLinksMenuVisible;
        }

		public setLinksMenuVisible(val) {
            this.isLinksMenuVisible = val;
        }

        public getDepositDisplay() {
            return this.isDepositDisplay;
        }

        public setDepositDisplay(val) {
            this.isDepositDisplay = val;
        }

    }


    export default [];




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/menu.service.ts